// extracted by mini-css-extract-plugin
module.exports = {"leaderboardFirst":"e_5","leaderboardSecond":"e_6"};